import React, { useEffect } from "react";
import { getImage } from "../Utils/image_helper";
import { Helmet } from "react-helmet";

// Simple confetti effect using CSS
// Uses a dedicated container outside React's tree to avoid DOM reconciliation conflicts
const Confetti = () => {
  useEffect(() => {
    // Create an isolated container that React doesn't manage
    const container = document.createElement("div");
    container.id = "confetti-container";
    container.style.cssText = "position:fixed;top:0;left:0;width:100%;height:100%;pointer-events:none;z-index:9999;overflow:hidden;";
    document.body.appendChild(container);

    const duration = 2000;
    const animationEnd = Date.now() + duration;
    const colors = ["#4a90e2", "#50c878", "#f5a623", "#ff4757"];

    const interval = setInterval(() => {
      const timeLeft = animationEnd - Date.now();

      if (timeLeft <= 0) {
        return clearInterval(interval);
      }

      const confetti = document.createElement("div");
      confetti.className = "confetti";
      confetti.style.backgroundColor =
        colors[Math.floor(Math.random() * colors.length)];
      confetti.style.left = Math.random() * 100 + "vw";
      container.appendChild(confetti); // ✅ append to isolated container, not body

      setTimeout(() => {
        if (container.contains(confetti)) confetti.remove();
      }, 2000);
    }, 100);

    return () => {
      clearInterval(interval);
      // Clean up our container on unmount
      if (document.body.contains(container)) document.body.removeChild(container);
    };
  }, []);

  return null;
};

const ThankYouPage = () => {
  return (
    <div className="d-flex flex-column min-vh-100 bg-light overflow-hidden">
      <Confetti />

      <Helmet>
        {/* Google Tag Manager */}
        <script>
          {`(function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
    new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
    j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
    'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
    })(window,document,'script','dataLayer','GTM-W4NDLJN9');`}
        </script>

        {/* Google Ads Conversion */}
        <script>
          {`gtag('event', 'conversion', {'send_to': 'AW-864162355/t3OcCKX8vdkDELOkiJwD'});`}
        </script>
      </Helmet>


      {/* Main Content */}
      <main className="container flex-grow-1 d-flex flex-column justify-content-center align-items-center text-center">
        <div
          className="card shadow p-5 rounded-4 animate__animated animate__zoomIn"
          style={{ maxWidth: "650px" }}
        >
          {/* Welcome Illustration */}
          <div className="mb-4">
            <img
              src={getImage("welcome")}
              alt="Welcome to Billnama"
              className="img-fluid animate__animated animate__fadeInDown"
              style={{ maxHeight: "250px" }}
            />
          </div>

          <h1 className="fw-bold mb-3">Thank You for Joining Billnama!</h1>
          <p className="text-muted mb-4">
            Welcome aboard! Your account is ready. Start creating invoices,
            tracking payments, and managing your business seamlessly.
          </p>

          <div className="d-grid gap-3 col-10 mx-auto">
            <a
              href="/dashboard"
              className="btn btn-primary btn-lg rounded-pill animate__animated animate__pulse animate__infinite"
            >
              Go to Dashboard
            </a>
          </div>
        </div>
      </main>

      {/* Footer */}
      <footer className="py-3 bg-white shadow-sm mt-auto animate__animated animate__fadeInUp">
        <div className="container text-center text-muted small">
          © {new Date().getFullYear()} Billnama. All rights reserved.
        </div>
      </footer>

      {/* Inline CSS for Confetti */}
      <style>{`
        .confetti {
          position: fixed;
          top: 0;
          width: 8px;
          height: 8px;
          opacity: 0.7;
          border-radius: 50%;
          animation: fall 2s linear forwards;
        }
        @keyframes fall {
          to {
            transform: translateY(100vh) rotate(720deg);
            opacity: 0;
          }
        }
      `}</style>
    </div>
  );
};

export default ThankYouPage;
